// Popisky EventType pro <select>
export const EVENT_TYPE_OPTIONS = [
  'races', 'camp', 'practice', 'other', 'repre', 'scm', 'association'
]

export const ALL_LEVELS = {
  // INTERNATIONAL: 'INTERNATIONAL',
  NATIONAL: 'NATIONAL',
  REGIONAL: 'REGIONAL',
  DISTRICT: 'DISTRICT',
  PRACTICE: 'PRACTICE',
  OTHER: 'OTHER',
  // SELECTIONS: 'SELECTIONS',
}

// Mapování povolených úrovní podle EventType
export const RACE_LEVEL_MAPPING = {
  // „races“, „camp“, „training“ i „other“ mají všechny úrovně
  races:       [
  //  ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.PRACTICE,
    ALL_LEVELS.OTHER,
  ],
  camp:        [
   // ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.PRACTICE,
    ALL_LEVELS.OTHER,
  ],
  practice:    [
   // ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.PRACTICE,
    ALL_LEVELS.OTHER,
  ],
  other:       [
  //  ALL_LEVELS.INTERNATIONAL,
    ALL_LEVELS.NATIONAL,
    ALL_LEVELS.REGIONAL,
    ALL_LEVELS.DISTRICT,
    ALL_LEVELS.PRACTICE,
    ALL_LEVELS.OTHER,
  ],

  // „repre“ a „scm“ jen PRACTICE, SELECTIONS, OTHER
  repre:       [
    ALL_LEVELS.PRACTICE,
    // ALL_LEVELS.SELECTIONS,
    ALL_LEVELS.OTHER,
  ],
  scm:         [
    ALL_LEVELS.PRACTICE,
    // ALL_LEVELS.SELECTIONS,
    ALL_LEVELS.OTHER,
  ],

  // „association“ jen PRACTICE a OTHER
  association: [
    ALL_LEVELS.PRACTICE,
    ALL_LEVELS.OTHER,
  ],
}